export default __webpack_public_path__ + "static/panel_long_1-d14602d839d303bc949dbd366a53f483.png";